module.exports = __webpack_public_path__ + "img/pay-value9.b307b342.png";